<template>
  <wow-card elevation="0" :show-title="false">
    <v-data-table dense :headers="headers" :items="placeOrderList" hide-default-footer disable-pagination>
      <template v-slot:item.availableProductData.warehouses="{ item }">
        <div v-for="(obj, index) in item.availableProductData.warehouses" :key="`${item.productID}_${obj.stock}_${index}`"
          class="d-flex justify-space-between my-1" style="border:solid 1px #686666;">
          <div class="accent white--text pa-1" style="width:100%;">{{ obj.name }}</div>
          <div class="stock-quantity pa-1">{{ obj.stock }}</div>
        </div>
      </template>
    </v-data-table>
    <v-card-actions class="d-flex justify-end">
      <v-btn :disabled='disablePlaceOrderBtn'
        :to="{ name: 'wowKitPlaceOrderSummary', params: { initiatedOrderID: orderObj.id, franchiseeId: orderObj.franchisee.id } }"
        small color="success">Place Order</v-btn>
    </v-card-actions>
  </wow-card>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import WowCard from '@/components/Orders/WowKitOrdering/kitComponents/vCard'
import _ from 'lodash'
export default {
  name: 'placeOrderDetails',
  components: {
    WowCard
  },
  props: {
    orderObj: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      headers: [
        { text: 'FCID', value: 'productID', align: 'center', sortable: true },
        { text: 'BOM Quantity', value: 'bomQuantity', align: 'center', sortable: true },
        { text: 'BOQ Quantity', value: 'boqQuantity', align: 'center', sortable: true },
        { text: 'Current Stock', value: 'availableProductData.currentstock', align: 'center', sortable: true },
        { text: 'Available Quantity', value: 'availableProductData.warehouses', align: 'center', sortable: true }
      ],
      placeOrderList: [],
      disablePlaceOrderBtn: false
    }
  },
  async created () {
    await this.getitemsDetails()
  },
  methods: {
    getitemsDetails: async function () {
      try {
        this.disablePlaceOrderBtn = false
        this.placeOrderList = []
        const res = await http.get(`${CONSTANTS.API_URL}/api/wow-kit/place-order-available-stock?InitatedOrdersID=${this.orderObj.id}`)
        if (res.status === 200) {
          if (!_.isArray(res.data)) {
            return this.$dialog.error({
              text: res.data,
              title: 'Error'
            })
          }
          res.data.forEach(obj => {
            let currentStock = obj.availableProductData.currentstock ? obj.availableProductData.currentstock : 0
            if (currentStock) {
              let totalStock = 0
              obj.availableProductData.warehouses.forEach(wareHouseObj => {
                totalStock = totalStock + wareHouseObj.stock
              })
              if (obj.bomQuantity > totalStock && obj.boqQuantity > totalStock) {
                if (!this.disablePlaceOrderBtn) {
                  this.disablePlaceOrderBtn = true
                }
              }
            } else {
              if (!this.disablePlaceOrderBtn) {
                this.disablePlaceOrderBtn = true
              }
            }
          })
          this.placeOrderList = res.data
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    }
  }
}
</script>
